import { getHallData } from '@/api'
import { DeskData } from '@/datamodel/deskdata'
import { ResponseData } from '@/datamodel/response-data'
// import { ResponseData } from '@/datamodel/responsedata'
import { MultipleDeskParams } from '@/datamodel/urlparams/MultipleDeskParams'
import router, { ROUTES } from '@/router'
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import { GoodRoadMutation } from '@/store/module/good-road'
import { EventBuss, SOCKET_MESSAGE } from '@/utils/constants'
import axios from 'axios'
import { SocketMessage, Table } from 'vue'
// import { EventBus, EventBusEvents } from '@/event/EventBus'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Options({})
export class SwitchTableMixin extends Vue {
    iN = useI18n().t
    //#region Properties
    selectedIndex = 'G002'
    hasPendingRequest = false
    desks: Table[] = []
    serviceTimer: number | boolean = false
    countDownTimer: number | boolean = false

    isCurrentClicked = -1

    emitter!: Vue['emitter']
    $emit!: Vue['$emit']

    failureCounter = 0

    //#endregion
    @Prop({ default: false })
    show!: boolean

    @Prop({ default: true }) showSelected!: boolean

    //#region Vuex Action
    @Action('hideLoading') hideLoading!: () => void
    @Action('showLoading') showLoading!: () => void
    @Action('getMultipleDesk') getMultipleDesk!: (
        model: MultipleDeskParams
    ) => Promise<ResponseData>
    @Action('destroySession') destroySession!: () => void
    //#endregion

    //#region Vuex Getter
    // @Getter('loadingIsVisible') loadingIsVisible!: boolean
    @Getter('token') token!: string
    @Getter('userId') userId!: string

    //#endregion
    //#region Vue Methods
    beforeMount(): void {
        this.emitter.on(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.on(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }
    mounted(): void {
        const params = new URLSearchParams(window.location.search)

        const _gameType = params.get('gameType')

        if (_gameType) {
            this.selectedIndex = _gameType
        }
        this.loadData()
    }
    beforeUnmount(): void {
        this.stopService()
        this.emitter.off(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.off(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    handleReconnectSuccess(): void {
        this.loadData(true)
    }
    //#endregion

    //#region WS Message
    handlesSocketMessages(_message: SocketMessage | any) {
        const { type } = _message
        const _type = type.toUpperCase()

        if (
            _type === SOCKET_MESSAGE.NEW_GAME ||
            _type === SOCKET_MESSAGE.END_GAME ||
            _type === SOCKET_MESSAGE.STOP_GAME ||
            _type === SOCKET_MESSAGE.CANCEL_GAME ||
            _type === SOCKET_MESSAGE.NEW_SHOE
        ) {
            // console.log(_type)
            const _table = (_message as SocketMessage).gameTable

            if (_table) {
                const _desk = this.desks.find(_d => _d.id === _table.id)

                if (_desk) {
                    const _index = this.desks.indexOf(_desk)
                    if (_index !== -1) this.desks[_index] = _table
                }

                store.commit(GoodRoadMutation.UPSERT_TABLE, _table)
            }
        }
    }
    //#region  Methods
    hideMe(): void {
        this.$emit('on-hide-switch-table')
    }

    changeIndex(num: string): void {
        if (num !== this.selectedIndex) {
            this.selectedIndex = num
            this.stopApiRequest()
            this.desks = []
            this.loadData()
        }
    }

    onSelectTable(desk: Table): void {
        if (router.currentRoute.value.name === ROUTES.GAME) {
            router.replace({
                query: {
                    desk: desk.id,
                    gameType: desk.gameTypeNo
                }
            })
        } else {
            router.push({
                name: ROUTES.GAME,
                query: {
                    desk: desk.id,
                    gameType: desk.gameTypeNo
                }
            })
        }

        //console.log()

        // this.$emit('on-switch-table', desk)
        // this.$emit('multi-switch-table', desk)
    }

    clickedItem(desk: number): void {
        // console.log(desk)
        if (this.isCurrentClicked === desk) {
            this.isCurrentClicked = -1
            return
        }

        this.isCurrentClicked = desk
    }

    loadData(_forceReload = false): void {
        if (!_forceReload) this.showLoading()
        let _params: any = {}

        let _gType = ''

        if (this.selectedIndex === 'G005') _gType = ''
        else _gType = this.selectedIndex

        _params = {
            token: this.token,
            gameTypeNo: _gType
        }

        getHallData(_params)
            .then(r => {
                this.failureCounter = 0
                if (!_forceReload) this.hideLoading()
                const response = r.data
                const { status } = response
                if (status === 200) {
                    // handle data
                    this.desks = response.data.gameTableList

                    store.commit(GoodRoadMutation.SET_HALL_TABLES, {
                        tables: response.data.gameTableList || [],
                        gameTypeNo: _gType
                    })

                    if (response.data.memberLimitList) {
                        store.commit(
                            UserMutation.SET_USER_INFO_LIMITS,
                            response.data.memberLimitList
                        )
                    }
                } else if (status === 301) {
                    // session is expired
                    this.stopApiRequest()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.failureCounter++

                    if (!_forceReload) {
                        this.hideLoading()
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )
                    }
                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })
                        return
                    }

                    this.serviceTimer = setTimeout(() => {
                        this.loadData(true)
                    }, 3000)
                }
            })
    }

    stopApiRequest() {
        if (typeof this.serviceTimer === 'number') {
            clearTimeout(this.serviceTimer)
            this.serviceTimer = false
        }
    }

    stopService(): void {
        if (typeof this.serviceTimer === 'number') {
            clearInterval(this.serviceTimer)
            this.serviceTimer = false
        }
    }

    //#endregion

    ////#region  Click Events
    onClickOutside(): void {
        this.$emit('close')
    }
    //#endregion

    //#region  Computed Properties
    get listData(): Table[] {
        return this.desks
    }

    //#endregion
}
